module.exports = __webpack_public_path__ + "static/img/hausv2.1931b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/hausv2.jpg
// module id = Yybt
// module chunks = 1